import { cn } from "@/common/helpers/utils";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import type { ReactElement, ReactNode } from "react";

interface DetailPageLayoutProps {
  header: ReactNode;
  aside?: ReactNode;
  children: ReactNode;
  variant?: CenteredLayoutVariant;
  className?: string;
}

export function DetailPageLayout({
  header,
  aside,
  children,
  variant = CenteredLayoutVariant.Wide,
  className,
}: DetailPageLayoutProps): ReactElement {
  return (
    <CenteredLayout variant={variant} className={className}>
      {header}
      <div className={cn("mt-2 grid items-start gap-6", aside && "lg:grid-cols-[minmax(0,1fr)_20rem]")}>
        <div className="flex min-w-0 flex-col gap-6">{children}</div>
        {aside && <aside className="flex flex-col gap-4 lg:sticky lg:top-4">{aside}</aside>}
      </div>
    </CenteredLayout>
  );
}
